<template>
    <div>
        <DxForm ref="formInstance" :form-data="model">
            <!-- <DxGroupItem>
                        <DxItem data-field="Id" editor-type="dxTextBox">
                            <DxLabel text="Id" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                        </DxItem>
                    </DxGroupItem> -->
            <DxTabbedItem>
                <DxTab :title="$t('sucesos.popup_guardar_suceso.nombre_pestana_datos')">
                    <DxGroupItem>
                        <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />
                        <DxItem data-field="IdInstalacion" editor-type="dxSelectBox"
                            :editor-options="instalacionEditorOptions" :col-span="6">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.id_instalacion')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                        </DxItem>

                        <DxItem data-field="Nombre" editor-type="dxTextBox" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.nombre')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                            <DxAsyncRule :validation-callback="validarNombre"
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_nombre_existente')" />
                        </DxItem>

                        <DxItem data-field="NumeroSerie" editor-type="dxTextBox" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.numero_serie')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                            <DxAsyncRule :validation-callback="validarNumeroSerie"
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_numero_serie_existente')" />
                        </DxItem>

                        <DxItem data-field="NombreEmpresaInstalacion" editor-type="dxTextBox" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.nombre_empresa_instalacion')" />
                        </DxItem>

                        <DxItem data-field="FechaInstalacion" editor-type="dxDateBox"
                            :editorOptions="dateTimeDxItemProps()" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.fecha_instalacion')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                        </DxItem>

                        <DxItem data-field="IpPublica" editor-type="dxTextBox" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.ip_publica')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                            <DxAsyncRule :validation-callback="validarIpPublica"
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_ip_publica_puerto_existente')" />
                        </DxItem>

                        <DxItem data-field="Puerto" editor-type="dxNumberBox" 
                            :editorOptions="{ 'min': 1, 'max': 65535 }" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.puerto')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                            <DxAsyncRule :validation-callback="validarPuerto"
                            :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_ip_publica_puerto_existente')" />
                        </DxItem>

                        <DxItem data-field="FrecuenciaDescargaEnMinutos" editor-type="dxNumberBox"
                            :editorOptions="{ 'min': 1, 'max': 1440 }" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.frecuencia_descarga_en_minutos')" />
                            <DxRequiredRule
                                :message="$t('oscilos.popup_guardar_oscilo.mensaje_validacion_obligatorio')" />
                        </DxItem>
                        <DxItem :col-span="3"/>
                        <DxItem data-field="DescargaHabilitada" editor-type="dxCheckBox" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.descarga_habilitada')" />
                        </DxItem>

                        <DxItem data-field="EnStandby" editor-type="dxCheckBox" :col-span="3">
                            <DxLabel :text="$t('oscilos.popup_guardar_oscilo.en_standby')" />
                        </DxItem>
                    </DxGroupItem>
                </DxTab>
                <DxTab :title="$t('sucesos.popup_guardar_suceso.nombre_pestana_adjuntos')" :visible="editing">
                    <DxSimpleItem template="templateFileUploader">
                    </DxSimpleItem>
                </DxTab>
            </DxTabbedItem>
            <template #templateFileUploader>
                <MultipleFileUploader :max-files="5" v-model:ficheros="ficheros"
                    :supported-extensions="AcceptedMimeTypes"
                    :textForAddAttachmentLabel="$t('oscilos.popup_guardar_oscilo.texto_para_etiqueta_anadir_adjunto')"
                    :textForAddAttachmentButton="$t('oscilos.popup_guardar_oscilo.texto_para_boton_anadir_adjunto')"
                    :textForNonDownloadableFiles="$t('oscilos.popup_guardar_oscilo.texto_para_ficheros_no_descargables')"
                    @fileDownloadRequested="onFileDownloadRequested">
                </MultipleFileUploader>
            </template>
        </DxForm>
    </div>
</template>

<script setup lang="ts">
import { isEqual, omit } from "lodash";
import { DxForm } from "devextreme-vue";
import { useIntl } from '@services/i18n';
import type { SaveOsciloModalModel } from "./Model";
import { useApi } from '@/.shared/.api/integration';
import type { AdjuntoOscilo, CreateOsciloModel, EditOsciloModel, ReferenciaFicheroModel } from "@/.shared/.api";
import { AcceptedMimeTypes } from "@/model/mime-types";
import { DxRequiredRule } from "devextreme-vue/data-grid";
import { useModalService } from "@/.shared/services/modal-service";
import { useModalBuilder } from '@/.shared/helpers/modal-building-helper';
import { computed, getCurrentInstance, onMounted, ref, toRaw, } from 'vue';
import { validateDxFormAsync } from '@/.shared/helpers/dxvalidation-helper';
import { dateTimeDxItemProps } from "@/.shared/helpers/datetime-field-helper";
import { toastSuccess, toastError } from '@/.shared/services/notification-service';
import { DxGroupItem, DxItem, DxLabel, DxColCountByScreen, DxAsyncRule, DxTabbedItem, DxTab, DxSimpleItem } from "devextreme-vue/form";
import MultipleFileUploader from "@/.shared/components/file-uploading/MultipleFileUploader.vue";
import type { ValidationCallbackData } from "devextreme/common";

const props = defineProps<{ osciloProp: SaveOsciloModalModel }>();
const editing = computed(() => (props.osciloProp != null) && (props.osciloProp.Id != null) && (props.osciloProp.Id != 0));
const model = computed(() => {
    return { ...{ Adjuntos: [] as AdjuntoOscilo[], AdjuntosExistentes: [] as ReferenciaFicheroModel[], FrecuenciaDescargaEnMinutos: 1 }, ...props.osciloProp };
});
const initialModel = computed(() => (editing.value) ? { ...toRaw(props.osciloProp) } : {} as SaveOsciloModalModel);
const idOscilo = computed(() => (!editing.value) ? undefined : (model.value as SaveOsciloModalModel).Id);

const api = useApi();
const intl = useIntl();
const modalBuilder = useModalBuilder();
const modalService = useModalService();

const ficheros = ref<Ficheros>({});
const formInstance = ref<DxForm>();
const instalacionEditorOptions = ref<any>(
    {
        displayExpr: "NombreCompleto",
        valueExpr: "Id",
        searchEnabled: "true"
        // onValueChanged: tipoComunicadoChanged
    });

onMounted(async () => {
    modalBuilder.setContext(getCurrentInstance()!);

    ficheros.value = model.value.AdjuntosExistentes.select(x => {
        return { file: new File([], x.Nombre), id: x.Id.toString(), fileName: x.Nombre, isRemote: true, status: "unchanged" } as Fichero
    }).toObject((x) => x.id) as Ficheros;

    let botones = modalBuilder.standardButtons.addOkCancel();
    botones.okButton.update((b) => {
        b.text = intl.i18n.t("oscilos.popup_guardar_oscilo.boton_anadir_oscilo")
        b.onClick = async () => {
            await guardarOscilo();
        }
    });

    botones.cancelButton.update((b) => {
        b.onClick = async () => {
            const title = (editing.value) ? intl.i18n.t("oscilos.popup_guardar_oscilo.titulo_confirmacion_cancelacion_edicion") : intl.i18n.t("oscilos.popup_guardar_oscilo.titulo_confirmacion_cancelacion_creacion");
            const message = (editing.value) ? intl.i18n.t("oscilos.popup_guardar_oscilo.mensaje_confirmacion_cancelacion_edicion") : intl.i18n.t("oscilos.popup_guardar_oscilo.mensaje_confirmacion_cancelacion_creacion");
            if (haSidoFormularioModificado()) {
                const result = await modalService.messageBox(message, title, 'yesNo', 'warning');
                if (result === "no")
                    return;
            }
            modalBuilder.close(false);
        }
    });

    // modalBuilder.addButton('btnExaminar', {
    //     text: 'Examinar', onClick: async () => {
    //         const result = await modalService.messageBox('¿Desea examinar?', 'Confirmación', 'yesNo', 'warning');
    //     }
    // }, { toolbar: 'bottom', location: 'before' })

    // model.value = {} as CreateOsciloModel;

    rellenarInstalacionesDxSelectBox();
});

async function rellenarInstalacionesDxSelectBox(): Promise<void> {
    const data = await api.callStandardApi("instalacionGetTodas", { showLoading: true });
    instalacionEditorOptions.value = { ...instalacionEditorOptions, dataSource: data };
}

async function validarNombre(params: ValidationCallbackData): Promise<boolean> {
    if (params.value)
        return await api.callStandardApi("osciloCheckNombre", { showLoading: false }, params.value, idOscilo.value);
    return true;
}

async function validarNumeroSerie(params: ValidationCallbackData): Promise<boolean> {
    if (params.value)
        return await api.callStandardApi("osciloCheckNumeroSerie", { showLoading: false }, params.value, idOscilo.value);
    return true;
}

async function validarIpPublica(params: ValidationCallbackData): Promise<boolean> {
    
    if (params.value) 
    {
        const ipPublica = params.value;
        const puerto = formInstance.value?.instance?.option('formData').Puerto;
        if (ipPublica) {
            return await api.callStandardApi("osciloCheckIpPort", { showLoading: false }, ipPublica.trim(), puerto, idOscilo.value);
        }
    }

    return true;
}

async function validarPuerto(params: ValidationCallbackData): Promise<boolean> {
    if (params.value) {
    const ipPublica = formInstance.value?.instance?.option('formData').IpPublica;
    const puerto = params.value;
    if (puerto) {
        return await api.callStandardApi("osciloCheckIpPort", { showLoading: false }, ipPublica?.trim() || ipPublica, puerto, idOscilo.value);
        }
    }
    return true;
}


function haSidoFormularioModificado(): boolean {
    return !(isEqual(toRaw(model.value), toRaw(initialModel.value)) && Object.getOwnPropertyNames(ficheros.value).all(x => ficheros.value[x].status === "unchanged"));
}

async function onFileDownloadRequested(fichero: Fichero) {
    const apiCallChain = await api.prepareStandardApi("osciloAttachmentDownload")(model.value.Id!, Number.parseInt(fichero.id));
    const href = `${apiCallChain.axiosInstance.defaults.baseURL!}${apiCallChain.axiosConfiguration.url}`;
    window.location.href = href;
}

async function guardarOscilo() {
    const result = await validateDxFormAsync(formInstance.value!.instance!);
    if (result.isValid) {
        const modalModel = omit(model.value, ["AdjuntosExistentes"]) as SaveOsciloModalModel; // Clonar el objeto model.value sin las propiedades entre []; omit es de lodash
        
        if (modalModel.IpPublica) {
            modalModel.IpPublica = modalModel.IpPublica.trim();
        }
        
        await setAdjuntos(modalModel, ficheros.value!);
        if (editing.value) {
            await api.callStandardApi("osciloEdit", { showLoading: true }, modalModel as EditOsciloModel);
            toastSuccess(intl.i18n.t('oscilos.popup_guardar_oscilo.mensaje_oscilo_editado'));
        }
        else {
            await api.callStandardApi("osciloCreate", { showLoading: true }, modalModel as CreateOsciloModel);
            toastSuccess(intl.i18n.t('oscilos.popup_guardar_oscilo.mensaje_oscilo_anadido'));
        }
        modalBuilder.close(true);
    } else {
        toastError(intl.i18n.t('oscilos.popup_guardar_oscilo.mensaje_validacion_no_superada'));
    }
}

async function setAdjuntos(modalModel: SaveOsciloModalModel, ficheros: Ficheros): Promise<void> {
    for (const key of Object.getOwnPropertyNames(ficheros)) {
        const fichero = ficheros[key];
        if (fichero.status === "new" || fichero.status === "modified") {
            const uploadId = await api.callStandardApi("osciloAttachmentUpload", {}, idOscilo.value!, fichero.fileName!, fichero.file!);
            modalModel.Adjuntos.push({ Id: 0, NombreFichero: fichero.fileName!, GuidSubida: uploadId });
        }
        else if (fichero.status === "unchanged") {
            modalModel.Adjuntos.push({ Id: parseInt(key), NombreFichero: null, GuidSubida: null });
        }
    }
}

</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

:deep(.dx-layout-manager .dx-tabpanel .dx-multiview-item-content) {
    padding: 12px;
}
</style>